import { get } from './fetch'

export const getTranslations = (cached = true) => {
  return get(`translations?cached=${Number(cached)}&categories=landing`)
}
